module.exports = __webpack_public_path__ + "img/icon-signal.940e6751.png";